__turbopack_context__.v({
  "blink": "Credits-module-scss-module__RNnWQG__blink",
  "borderTop": "Credits-module-scss-module__RNnWQG__borderTop",
  "credit": "Credits-module-scss-module__RNnWQG__credit",
  "credits": "Credits-module-scss-module__RNnWQG__credits",
});
